export default __webpack_public_path__ + "static/media/infecciones_piel_partes_blandas.ba95599a.pdf";